import { render } from "./Emergency_Contacts.vue?vue&type=template&id=3fa2e6e2&scoped=true"
import script from "./Emergency_Contacts.vue?vue&type=script&lang=js"
export * from "./Emergency_Contacts.vue?vue&type=script&lang=js"

import "./Emergency_Contacts.vue?vue&type=style&index=0&id=3fa2e6e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa2e6e2"]])

export default __exports__